export const meQueryKey = ['me'] as const;
